import { type Analytics, getAnalytics, logEvent, setUserProperties } from "firebase/analytics";
import { initializeApp, getApps } from "firebase/app";

import appConfig from "config/app";
import { type AccountQualityEnum, type AnalyticsCustomEventNameEnum } from "src/graphql/generated/types";

const validFirebaseConfig =
  appConfig.firebaseConfig && Object.values(appConfig.firebaseConfig).every(Boolean);

let analytics: Analytics | null = null;

export const initializeAnalytics = () => {
  if (validFirebaseConfig && appConfig.firebaseConfig) {
    // Check if a Firebase app has already been initialized
    if (!getApps().length) {
      initializeApp(appConfig.firebaseConfig);
    }
    analytics = getAnalytics();
  }
};

export function setCurrentQuality(quality: AccountQualityEnum) {
  if (!analytics) {return;}
  setUserProperties(analytics, { quality });
}

export function logScreenName(screenName: string) {
  if (!analytics) {return;}
  logEvent(analytics, "page_view", { screen_name: screenName });
}

export function logCustomEvent(eventName: AnalyticsCustomEventNameEnum) {
  if (!analytics) {return;}
  logEvent(analytics, eventName);
}
